<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header= "Información del Vencimiento">
          <b-form>
            <b-form-group
              label="Banco"
              label-for="banco"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="banco" 
                :value="banco" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Tarjeta"
              label-for="tarjetaMarca"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="tarjetaMarca" 
                :value="tarjetaMarca" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Nro.Cuenta"
              label-for="numeroCuenta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="numeroCuenta" 
                :value="numeroCuenta" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Fecha de Cierre"
              label-for="fechaCierre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaCierre" 
                v-model="fechaCierre" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Fecha de Vencimiento"
              label-for="fechaVencimiento"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaVencimiento" 
                v-model="fechaVencimiento" 
                type="date">
              </b-form-input>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'tarjetaResumen/getField',
  mutationType: 'tarjetaResumen/updateField',
});

export default {
  name: 'TarjetaResumenABM',
  components: {
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,

      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'tarjetaId',
      'banco',
      'tarjetaMarca',
      'numeroCuenta',
      'fechaCierre',
      'fechaVencimiento'
    ])
  },  
  created() {
    let tarjetaId = 0;
    if (this.$route.params){
      if (this.$route.params.tarjetaId){
        tarjetaId = this.$route.params.tarjetaId;
      }
    }

    this.showSpinner();
    this.$store.dispatch('tarjetaResumen/inicializar', tarjetaId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('tarjetaResumen/save')
            .then(() => this.showModalMsj('Los cambios se registraron con éxito', this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        }
      } 
    },
    goList() {
      this.$router.push({ name: "TarjetasVencimientos",
                          params: { tarjetaId: this.tarjetaId }});
    },
  },
  validations: {
  },   
}
</script>

<style>
</style>
